// Use env vars at build time (set in CI per branch). Fallbacks for local dev.
const baseURL =
  process.env.REACT_APP_BASE_URL ||
  "https://api.rentbeta.africa/api/v1";
const imageURL =
  process.env.REACT_APP_IMAGE_URL ||
  "https://api.rentbeta.africa";

export { baseURL, imageURL }